import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { L10nLocale, L10N_LOCALE } from 'angular-l10n';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BaseService } from 'src/app/core/services/base.service';
import { MessageBusService } from 'src/app/core/services/message-bus.service';
import { ComponentLookup } from 'src/app/shared/decorators/component-lookup.decorator';
import { IControlComponent } from 'src/app/shared/interfaces/control-component';
import { FormComponentData } from 'src/app/shared/models/people/form-control.model';
import { LocationPublicProfile, PublicProfile } from 'src/app/shared/models/people/public-profile.model';

@Component({
  selector: 'app-appointment-locations',
  templateUrl: './appointment-locations.component.html',
  styleUrls: ['./appointment-locations.component.css'],
  encapsulation: ViewEncapsulation.None
})
@ComponentLookup('AppointmentLocationsComponent')
export class AppointmentLocationsComponent implements OnInit, OnDestroy, IControlComponent {
  data: FormComponentData;

  private ngUnsubscribe = new Subject();

  publicProfile: PublicProfile;
  finishLoading: boolean = false;
  showLocations: boolean = true;
  showCard: boolean = true;
  selectedLocationId: number = 0;

  constructor(
    private route : ActivatedRoute,
    protected messageBusService: MessageBusService,
    private baseService: BaseService,
    @Inject(L10N_LOCALE) public locale: L10nLocale
  ) { }
  
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params && params.location) {
        this.selectedLocationId = parseInt(params.location);
      }        
    });

    this.messageBusService.onSendPublicProfile()
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(message => {
      this.publicProfile = message.publicProfile;
      this.showCard = (this.publicProfile.localidades != null && this.publicProfile.localidades.length > 0);
      this.finishLoading = true;
    });

    if (this.data)
      this.baseService.sendComponentFinishLoadingMessage(this.data);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  toggleLocations():void {
    this.showLocations = !this.showLocations;
  }

  locationTrackBy(index : number, item: LocationPublicProfile):number{
    return item.idPerfilPublicoDetalle; 
  }

}
